import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {CustomSelectComponent} from "./custom-select.component";
import {CustomSelectOptionComponent} from "./custom-select-option/custom-select-option.component";
import {CdkConnectedOverlay, CdkOverlayOrigin} from "@angular/cdk/overlay";
import {SpriteVersionDirective} from "../../../../../_directives/spriteVersionDirective";
import {ReactiveFormsModule} from "@angular/forms";
import {PollMoveObserverDirective} from "../../../../../_directives/pollMoveObserver.directive";
import {OutsideClickDirective} from "../../../../../_directives/outside-click.directive";
import { CustomSelectFeaturedOptionsComponent } from './custom-select-featured-options/custom-select-featured-options.component';
import {InitialsAvatarModule} from "../../common/initials-avatar/initials-avatar.module";

@NgModule({
  declarations: [
  ],
  imports: [
    CustomSelectComponent,
    CustomSelectOptionComponent,
    PollMoveObserverDirective,
    CustomSelectFeaturedOptionsComponent,
    CommonModule,
    CdkConnectedOverlay,
    CdkOverlayOrigin,
    SpriteVersionDirective,
    ReactiveFormsModule,
    OutsideClickDirective,
    InitialsAvatarModule
  ],
  exports: [
    CustomSelectComponent,
    CustomSelectOptionComponent,
    PollMoveObserverDirective,
    CustomSelectFeaturedOptionsComponent
  ]
})
export class CustomSelectModule {
}
